/**
 * ローカル開発環境のユーザー画面・管理画面のオリジン。
 *
 * 値はビルド時に localConfiguration.ts から vite の define で埋め込まれる。
 * worktree ごとにポートが変わるため、リダイレクト処理でポートをハードコードしない。
 */
const webappOrigin = process.env.WEBAPP_ORIGIN ?? 'http://localhost:9082';
const adminWebappOrigin = process.env.ADMIN_WEBAPP_ORIGIN ?? 'http://localhost:9098';
// クラウドDB利用モード（start-with-cloud）のオリジン。ビルドしたモードに関わらず埋め込まれる
const cloudWebappOrigin = process.env.CLOUD_WEBAPP_ORIGIN ?? 'https://localhost:9182';
const cloudAdminWebappOrigin = process.env.CLOUD_ADMIN_WEBAPP_ORIGIN ?? 'https://localhost:9198';

const hostOf = (origin: string): string => new URL(origin).host;

export const LocalOrigins = {
  webapp: webappOrigin,
  adminWebapp: adminWebappOrigin,
  webappHost: hostOf(webappOrigin),
  adminWebappHost: hostOf(adminWebappOrigin),
  cloudWebappHost: hostOf(cloudWebappOrigin),
  cloudAdminWebappHost: hostOf(cloudAdminWebappOrigin),
};

const loopbackAliases = (host: string): string[] => [host, host.replace('localhost:', '127.0.0.1:')];

/**
 * 別ポート・127.0.0.1 経由のアクセスを canonical なホストへ寄せるための対応表を作ります。
 */
const hostMappingTo = (canonicalHost: string, ...hosts: string[]): Record<string, string> =>
  Object.fromEntries(
    hosts
      .flatMap(loopbackAliases)
      .filter((host) => host !== canonicalHost)
      .map((host) => [host, canonicalHost])
  );

/** ユーザー画面用エントリーポイントへのアクセスを、ユーザー画面用ホストへ寄せる対応表 */
export const userWebappHostMapping = hostMappingTo(
  LocalOrigins.webappHost,
  LocalOrigins.webappHost,
  LocalOrigins.adminWebappHost
);

/** 管理画面用エントリーポイントへのアクセスを、管理画面用ホストへ寄せる対応表 */
export const adminWebappHostMapping = hostMappingTo(
  LocalOrigins.adminWebappHost,
  LocalOrigins.adminWebappHost,
  LocalOrigins.webappHost
);

/** 管理画面のURLをユーザー画面のURLに読み替えます */
export const toUserWebappHref = (href: string): string =>
  href.replace(LocalOrigins.adminWebappHost, LocalOrigins.webappHost);
